import { usePositionsDrawerOpenOrdersTab } from "#/store/app/positionsDrawer/positionsDrawerOpenOrdersTab";

import { Contents } from "../Contents/Contents";
import { AllOpenOrders } from "./components/AllOpenOrders/AllOpenOrders";
import { OptionOpenOrders } from "./components/OptionOpenOrders/OptionOpenOrders";
import { PerpOpenOrders } from "./components/PerpOpenOrders/PerpOpenOrders";

export interface OpenOrdersProps {
  isPortfolioVariant?: boolean;
}

export const OpenOrders: React.FC<OpenOrdersProps> = ({
  isPortfolioVariant,
}) => {
  const { positionsDrawerOpenOrdersTab } = usePositionsDrawerOpenOrdersTab();

  return (
    <Contents isEmpty={false} animateKey={positionsDrawerOpenOrdersTab}>
      {positionsDrawerOpenOrdersTab === "all" && (
        <AllOpenOrders isPortfolioVariant={isPortfolioVariant} />
      )}
      {positionsDrawerOpenOrdersTab === "options" && (
        <OptionOpenOrders isPortfolioVariant={isPortfolioVariant} />
      )}
      {positionsDrawerOpenOrdersTab === "perps" && (
        <PerpOpenOrders isPortfolioVariant={isPortfolioVariant} />
      )}
    </Contents>
  );
};
